import templateUrl from 'emun.salesrep/salesrep-sales-goals-category.htm';
import productSalesPopup from "emun.salesrep/product-sales-popup";
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesGoalsCategoryController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
		let $ctrl = this;
		//        $ctrl.mode = "list";
		if (!$ctrl.mode) { $ctrl.mode = 'list'; }
		$ctrl.total = 0;
		$ctrl.colors = salesrepConfig.chartColors;
		$ctrl.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.labels[tooltipItem.index];
						let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
					}
				}
			}
		};
		var context = $ctrl.context || 'rep';

		var filterType = "SalesRepID";
		var repFilter = "";
		if (context !== 'writingRep') {
			if (context !== 'executive') {
				if (context === 'manager') {
					filterType = 'ManagerId';
				}
				repFilter = "&" + filterType + "=" + $ctrl.rep.id;
			}
		}

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup && $ctrl.repGroupId) {
			repFilter = '&RepGroup=' + $ctrl.repGroupId;
		}
		if (context === 'writingrep') {
			if ($ctrl.writingRepId) {
				repFilter = "&WritingRepID=" + $ctrl.writingRepId;
			}
		}

		//        var url = 'QueryOrderLineTotals.json?dateRange=YTD&grouping=strCategory' + repFilter;
		var url = 'QuerySalesDailyCategoryTotals.json?Sum=SalesDailyTotal&GroupBy=Category&OrderBy=Category&dateRange=YTD' + repFilter;

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup) {
			url = url + '&RepGroupName=' + $ctrl.repGroup;
		}
		if ($ctrl.insideSales === 'true') {
			url = url + '&IsInsideSales=true';
		}
		$ctrl.categories = createAutoQuery({
			url: 'QueryProductCategories.json',
			orderBy: 'Label',
			autoLoad: true,
			onLoaded: function (args) {
				$ctrl.categoryTotals = createAutoQuery({
					url: url,
					autoLoad: true,
					onLoaded: function (totals) {
						$ctrl.chartLabels = [];
						$ctrl.chartData = [];
						totals.results.forEach(function (total) {
							args.results.forEach(function (c) {
								if (c.id === total.category) {
									$ctrl.chartLabels.push(c.id);
									$ctrl.chartData.push(Math.round(total.sumSalesDailyTotal));
									$ctrl.total += total.sumSalesDailyTotal;
									total.categpryName = c.label;

									var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisYearTD&GroupBy=Category&OrderBy=Category' + '&categoryId=' + c.id;
									if ($ctrl.repGroup) {
										if ($ctrl.repGroup !== 'ALL') {
											salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
										}
									}
									//if (filter !== '') {
									//  salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
									//}
									if (context !== 'writingRep' && context !== 'executive') {
										if (filterType !== '') {
											salesGoalsUrl = salesGoalsUrl + '&' + filterType + '=' + $ctrl.rep.id;
										}
									}
									else {
										if ($ctrl.writingRepId) {
											salesGoalsUrl = salesGoalsUrl + '&WritingRep=' + $ctrl.writingRepId;
										}
									}
									if ($ctrl.insideSales === 'true') {
										// salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=true';
									}
									else {
										salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
									}

									$ctrl.salesGoals = createAutoQuery({
										url: salesGoalsUrl,
										autoLoad: true,
										onLoaded: function (args) {
											args.results.forEach(function (goals) { //HACK-->this will only loop once
												total.goal = goals.sumSalesGoalThisYearTD;
												if (total.goal > 0) {
													total.percent = Math.round((total.sumSalesDailyTotal / total.goal) * 100);
												} else {
													total.percent = 0;
												}
											});
										}
									});
								}
							});
						});
					}
				});
			}
		});
	}
	showCategoryDetails(category) {
		let $ctrl = this;
		return productSalesPopup({
			context: $ctrl.context,
			category: category,
			rep: $ctrl.rep,
			title: category + " Product Sales"
		}).then(function () {
			return;
		});
	}

}

let SalesRepSalesGoalsCategory = {
	bindings: {
		rep: '<',
		repGroup: '@',
		repGroupId: '@',
		context: '@',
		mode: '@',
		insideSales: '@',
		writingRepId: '@'
	},
	//require:{
	//    container: '^salesrepDashboard'
	//},
	controller: SalesRepSalesGoalsCategoryController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SalesRepSalesGoalsCategory;